module.exports = __webpack_public_path__ + "img/whatshot.ddd4fe28.svg";